module.exports = __webpack_public_path__ + "img/wyb.9e84268.png";